import { Radio, RadioGroup, Text } from '@idaho-aeyc/ui-kit';
import { Flex, RadioChangeEvent } from 'antd';
import { useTranslation } from '@packages/utils';
import styled from 'styled-components';
import useRegistrationContext, {
  YES_NO_OPTIONS,
} from '../../../context/NewRegistrationModalContext';
import { stepFiveKey } from '../../../../RegistrationModal/RegistrationModal.data';

const Container = styled(Flex)`
  margin-bottom: 32px;
  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
`;

const PhotoReleaseSection = () => {
  const { t } = useTranslation({
    keyPrefix: stepFiveKey,
    lng: 'translate',
  });

  const { registrationValues, setRegistrationValues } =
    useRegistrationContext();

  return (
    <Container vertical gap={8}>
      <h2>{t('PHOTO_RELEASE')}</h2>
      <Text>{t('PHOTO_RELEASE_DESCRIPTION')}</Text>
      <RadioGroup
        onChange={(e: RadioChangeEvent) => {
          const allowedTakePicture = e.target.value;

          setRegistrationValues({
            ...registrationValues,
            allowedTakePicture,
          });
        }}
        value={registrationValues.allowedTakePicture}
        style={{
          display: 'flex',
          gap: 8,
        }}
        data-cy="radioBtn_permission"
      >
        {YES_NO_OPTIONS.map(option => (
          <Radio key={option.value} value={option.value}>
            {t(option.label.toUpperCase())}
          </Radio>
        ))}
      </RadioGroup>
    </Container>
  );
};

export default PhotoReleaseSection;
